<template>
    <section id="about">
        <div class="container">
            <div class="columns">
                <div class="column dashboard is-6 is-hidden-touch">
                    <img src="../assets/images/about/dashboard.png" >
                </div>
                <div class="column is-6">
                    <div class="columns">
                        <div class="column is-10 is-offset-2-desktop">
                            <h2 class="title">
                                {{$t('AboutTitle')}}
                            </h2>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="columns">
                                <div class="column is-2 has-text-centered check">
                                    <img  src="../assets/images/about/vink.svg">
                                </div>
                                <div class="column is-10">
                                    <p>
                                        {{$t('AboutBullet1')}}
                                    </p>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-2 has-text-centered check">
                                    <img  src="../assets/images/about/vink.svg">
                                </div>
                                <div class="column is-10">
                                    <p>
                                        {{$t('AboutBullet2')}}                                        
                                    </p>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-2 has-text-centered check">
                                    <img  src="../assets/images/about/vink.svg">
                                </div>
                                <div class="column is-10">
                                    <p>
                                        {{$t('AboutBullet3')}} 
                                    </p>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-2 has-text-centered check">
                                    <img  src="../assets/images/about/vink.svg">
                                </div>
                                <div class="column is-10">
                                    <p>
                                        {{$t('AboutBullet4')}} 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="columns zorgmanagement">
                <div class="column is-6 is-hidden-mobile">
                    <h2 class="title ">
                        {{$t('CareManagementTitle')}}
                    </h2>
                </div>
                <div class="column is-6 is-hidden-mobile">
                    <img  src="../assets/images/about/zorgmanagement.svg">
                </div>

                
                <div class="column is-6 is-hidden-tablet">
                    <img  src="../assets/images/about/zorgmanagement.svg">
                </div>

                <div class="column is-6 is-hidden-tablet">
                    <h2 class="title ">
                        {{$t('CareManagementTitle')}}
                    </h2>
                </div>
            </div>

            <div class="columns padding-large">
                <div class="column is-4">
                    <div class="columns">
                        <div class="column has-text-centered check">
                            <img  src="../assets/images/about/linkDossier.svg">
                        </div>
                    </div>
                    <div class="columns has-text-centered">
                        <div class="column is-8 is-offset-2">
                            <p>
                                {{$t('CareManagementItem1')}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="columns">
                        <div class="column has-text-centered check">
                            <img  src="../assets/images/about/filter.svg">
                        </div>
                    </div>
                    <div class="columns has-text-centered">
                        <div class="column is-8 is-offset-2">
                            <p>
                                
                        {{$t('CareManagementItem2')}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="columns">
                        <div class="column has-text-centered check">
                            <img  src="../assets/images/about/herinnering.svg">
                        </div>
                    </div>
                    <div class="columns has-text-centered">
                        <div class="column is-8 is-offset-2">
                            <p>                               
                                {{$t('CareManagementItem3')}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
    </section>
</template>

<script>
export default {
  name: 'About',
  data () {
      return {
      }
  }
}
</script>

